import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  ViewChild,
  OnDestroy,
} from "@angular/core";
import { Subscription, fromEvent } from "rxjs";
import {
  map,
  startWith,
  debounceTime,
  distinctUntilChanged,
} from "rxjs/operators";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { PageEvent } from "@angular/material/paginator";
import { Observable } from "rxjs";
import { ToastrService } from "ngx-toastr";

import { ProjectService } from "@service/project.service";
import { Project } from "@model/Project";
import { Paginate } from "@model/Paginate";
import { ModalProjectComponent } from "@component/modal-project/modal-project.component";
import { ModalStudentProfileComponent } from "@component/modal-student-profile/modal-student-profile.component";
import { ModalRepositoryComponent } from "@component/modal-repository/modal-repository.component";
import { ModalResearcherProfileComponent } from "@component/modal-researcher-profile/modal-researcher-profile.componente";
import { ModalAttendingComponent } from "@component/modal-attending/modal-attending.component";
import { Events } from "@service/events.service";
import { AuthService } from "@service/auth.service";

import { select, Store } from "@ngrx/store";
import { MenuState, getMenuItemByTitle } from "@app/store";
import * as Cookies from "js-cookie";
import { MenuItem } from "@service/app-toolbar/app-toolbar.service";
import { Repository } from "@model/Repository";
import { RepositoriesService } from "@service/repositories.service";
import { InvitationsService } from "@service/invitations.service";
import { Invitation } from "@model/Invitation";
import { MatDialog } from "@angular/material/dialog";
import { ModalSatisfactionSurveyComponent } from "@component/modal-satisfaction-survey/modal-satisfaction-survey.component";
import { UsersService } from "@service/users.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("searchInput", { read: ElementRef, static: false })
  searchInput: ElementRef;

  private subscription: Subscription = new Subscription();
  term: string = "";
  modalOptions: NgbModalOptions;
  modalStudentProfileOptions: NgbModalOptions;
  modalRepositoryOptions: NgbModalOptions;
  projects: Paginate<Project> = null;
  myProjectMenuItem$: Observable<MenuItem>;
  repositories: Paginate<any> = null;
  loading = true;
  public pageEvent: PageEvent;
  public page: Paginate<Project> = {
    page: 20,
    current: 0,
    total: 0,
  } as Paginate<Project>;
  public pageSizeOptions: number[] = [5, 10, 20];
  isFolder = true;
  filter: string = null;
  searchFieldPlaceholder = 'pasta';

  constructor(
    private readonly toast: ToastrService,
    private store: Store<MenuState>,
    private authService: AuthService,
    private projectService: ProjectService,
    private modalService: NgbModal,
    private events: Events,
    private repositoriesService: RepositoriesService,
    private readonly invitationsService: InvitationsService,
    public dialog: MatDialog,
    private usersService: UsersService
  ) {
    this.events.setPlaylistUrl("PLjqmpybbUA6voLNzGfuo5bdN4394UBQpc");

    this.modalOptions = {
      backdrop: "static",
      backdropClass: "customBackdrop",
      size: "lg",
    };

    this.modalStudentProfileOptions = {
      backdrop: "static",
      backdropClass: "customBackdrop",
      size: "lg",
    };

    this.modalRepositoryOptions = {
      backdrop: "static",
      backdropClass: "customBackdrop",
      size: "lg",
    };
  }

  ngOnInit() {
    this.myProjectMenuItem$ = this.store.pipe(
      select(getMenuItemByTitle("meus projetos"))
    );
    ProjectService.setTemplate(null);
    localStorage.removeItem("blindSelection");
    this.projectService.setEnterProject(false);

    this.pageEvent = this.getData({
      previousPageIndex: 0,
      pageIndex: this.page.current,
      pageSize: this.page.page,
      length: this.page.total,
    });
    this.events.on("deleteProject").subscribe((id: number) => {
      const index = this.position(id);

      if (index > -1) {
        this.projects.data.splice(index, 1);
        const my_projects_total = +Cookies.get("my_projects_total") - 1;
        this.events.setMyProjectsTotal(my_projects_total);
      }
    });

    this.events.on("deleteRepository").subscribe((id: number) => {
      const index = this.position(id);

      if (index > -1) {
        this.repositories.data.splice(index, 1);
      }
    });

    this.events.on("leaveProject").subscribe(() => {
      this.pageEvent = this.getData({
        previousPageIndex: 0,
        pageIndex: 0,
        pageSize: 20,
        length: 0,
      });
    });

    this.events.setVoucherExpiresAt(this.authService.user.voucher_expires_at);

    // if (this.authService.user.is_superuser) {
    //   this.events.broadcast('is_superuser', this.authService.token);
    // }

    this.authService.removeInvitationRole();

    if (!this.authService.user.student_institution) {
      const modalRef = this.modalService.open(
        ModalStudentProfileComponent,
        this.modalStudentProfileOptions
      );
      modalRef.result.then((res) => {}).catch(() => {});
    }

    if (!this.authService.user.profile_type) {
      const modalRef = this.modalService.open(ModalResearcherProfileComponent, {
        backdrop: "static",
        backdropClass: "customBackdrop",
        size: "sm",
      });
      modalRef.result.then((res) => {}).catch(() => {});
    }

    if (!this.authService.user.attending) {
      this.dialog.open(ModalAttendingComponent, {
        width: "500px",
        data: { userId: this.authService.user.id },
      });
    }

    this.usersService.getUserAccess(this.authService.user.id).subscribe(res => {
      if (!Cookies.get('isAnswered') && res > 3) {
        this.dialog.open(ModalSatisfactionSurveyComponent, {
          width: "550px"
        });
      }
    });

    this.events.on("editRepositorySuccess").subscribe(
      () =>
        (this.pageEvent = this.getData({
          previousPageIndex: 0,
          pageIndex: 0,
          pageSize: 20,
          length: 0,
        }))
    );
    this.projectService.removeReferenceType();

    this.invitationsService
      .paginate(0, 20)
      .subscribe((pagedData: Paginate<Invitation>) => {
        if (pagedData.total > 0) {
          this.toast.info(
            "Você possui alguns convites. Por favor, verifique a página de convites.",
            "",
            {
              timeOut: 3000,
            }
          );
        }
      });
  }

  getData(event?: PageEvent): PageEvent {
    this.repositoriesService
      .getRepositories(event.pageSize, event.pageIndex + 1, this.filter, this.term)
      .subscribe(
        (repositories: Paginate<Repository>) => {
          console.log(repositories)
          this.page = { ...this.page, total: repositories.total };
          this.repositories = repositories;
          this.loading = false;
        },
        () => (this.loading = false)
      );
    return event;
  }

  ngAfterViewInit() {
    const term$ = fromEvent(this.searchInput.nativeElement, "keyup").pipe(
      map((event: any) => event.target.value),
      startWith(""),
      debounceTime(400),
      distinctUntilChanged()
    );

    this.subscription.add(
      term$.subscribe((term) => {
        this.term = term;
        this.getData(this.pageEvent);
      })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public get isProjectsEmpty(): boolean {
    return this.projects === null || this.projects.data.length == 0;
  }

  public get isRepositoriesEmpty(): boolean {
    return this.repositories === null || this.repositories.data.length === 0;
  }

  openProject() {
    this.modalService
      .open(ModalProjectComponent, this.modalOptions)
      .result.then((project = null) => {
        if (project) {
          this.projects.total += 1;
          // this.projects.data.push(project);
          this.pageEvent = this.getData({
            previousPageIndex: 0,
            pageIndex: 0,
            pageSize: 20,
            length: 0,
          });
          const my_projects_total = +Cookies.get("my_projects_total") + 1;
          this.events.setMyProjectsTotal(my_projects_total);
        }
      });
  }

  private position(id: number): number {
    return this.repositories.data.map((el) => el.id).indexOf(id);
  }

  openImg(imgName, idBtn, clasBtn) {
    let notClick: any[] = [
      "assets/img/project/home/btnCiclo1_Sem_Click.png",
      "assets/img/project/home/btnCiclo2_Sem_Click.png",
      "assets/img/project/home/btnCiclo3_Sem_Click.png",
      "assets/img/project/home/btnCiclo4_Sem_Click.png",
    ];
    let i, x, img, btn, url;

    if (idBtn === "planning") {
      btn = 0;
      url = "assets/img/project/home/btnCiclo1_Com_Click.png";
    } else if (idBtn === "develo") {
      btn = 1;
      url = "assets/img/project/home/btnCiclo2_Com_Click.png";
    } else if (idBtn === "config") {
      btn = 2;
      url = "assets/img/project/home/btnCiclo3_Com_Click.png";
    } else if (idBtn === "editorText") {
      btn = 3;
      url = "assets/img/project/home/btnCiclo4_Com_Click.png";
    }

    img = document.getElementsByClassName(clasBtn);
    for (i = 0; i < img.length; i++) {
      if (i === btn) {
        img[i].src = url;
      } else {
        img[i].src = notClick[i];
      }
    }

    x = document.getElementsByClassName("picture");
    for (i = 0; i < x.length; i++) {
      x[i].style.display = "none";
    }
    document.getElementById(imgName).style.display = "flex";
  }

  newRepository() {
    this.modalService
      .open(ModalRepositoryComponent, this.modalRepositoryOptions)
      .result.then((repository = null) => {
        if (repository) {
          this.repositories.total += 1;
          this.pageEvent = this.getData({
            previousPageIndex: 0,
            pageIndex: 0,
            pageSize: 20,
            length: 0,
          });
        }
      });
  }
  getFilterValue(filter: string, isFolder = false) {
    this.isFolder = isFolder;
    this.filter = filter;

    switch (filter) {
      case 'Author':
        this.searchFieldPlaceholder = 'autor';
        break;
      case 'Title':
        this.searchFieldPlaceholder = 'título';
        break;
      default:
        this.searchFieldPlaceholder = 'pasta';
        break;
    }

    this.pageEvent = this.getData({
      previousPageIndex: 0,
      pageIndex: 0,
      pageSize: 20,
      length: 0,
    });
  }
}
